import { ColumnDef } from "@tanstack/react-table";
import { DetailedUserWithStats } from "@/user/user.d";

export const TotalReferralsCol = (): ColumnDef<DetailedUserWithStats> => ({
  header: "Referrals",
  accessorFn: (row) => row.stats?.total_referral_count ?? 0,
  size: 100,
});
